import React from 'react';
import { Button, Tooltip, Form, Input } from 'antd';
import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Impresión"}>
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>

                        </div>
                    )
                },

                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre'
                },
                {
                    title: 'Código Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia'
                },
                {
                    title: 'Código Barra',
                    dataIndex: 'codigoBarra',
                    key: 'codigoBarra'
                },
                {
                    title: 'Marca',
                    dataIndex: 'nombreMarca',
                    key: 'nombreMarca'
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento'
                },
                {
                    title: 'Lista de Precio',
                    dataIndex: 'nombreListaPrecio',
                    key: 'nombreListaPrecio'
                },
                {
                    title: 'Precio Unitario Soles',
                    dataIndex: 'precioUnitarioSoles',
                    key: 'precioUnitarioSoles',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )

                },
                {
                    title: 'Precio Unitario Dolares',
                    dataIndex: 'precioUnitarioDolares',
                    key: 'precioUnitarioDolares',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },

                {
                    title: 'Stock Disponible',
                    dataIndex: 'stockDisponible',
                    key: 'stockDisponible',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },



            ]}
        />
    );
}